import {
  GET_FOC_REPORT_REQUEST,
  GET_FOC_REPORT_SUCCESS,
  GET_FOC_REPORT_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const getfocReport = (token, values) => (dispatch) => {
  dispatch({ type: GET_FOC_REPORT_REQUEST });
  const newData = {
    date_from: moment(values.from_date).format("MM-DD-YYYY"),
    date_to: moment(values.to_date).format("MM-DD-YYYY"),
    gender_id: values.gender === "All" || values.gender === undefined ? null : values.gender,
    sku: values.sku === undefined || values.sku === "" ? null : values.sku,
    memo: values.memo === undefined ? null : values.memo,
    customer_id: values.customer_id === undefined || values.customer_id === "All" ? null : values.customer_id,
  };

  return axios({
    method: "POST",
    url: `${BASEURL}getAll/FocReport`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData
  })
    .then((response) => {
      return dispatch({
        type: GET_FOC_REPORT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_FOC_REPORT_ERROR,
        payload: [],
      });
    });
};
